import dayjs from 'dayjs';
import { TrialStar } from '@/assets/icons/bold';
import { useAuth } from '@/hooks';
import { Flex, Icon, Link, Text } from '@chakra-ui/react';
import { useTrailNudge } from '../../app/NudgeManager';
import { X } from '@kula-ai/icons-core';

const getRemainingDays = (time) => {
  const diffrence = dayjs(time).diff(Date.now(), 'day');
  if (diffrence >= 2) return ` ${diffrence} days`;
  else if (diffrence === 1) return ` 1 day`;
  else return `Today`;
};

export const TrialNudge = () => {
  const { currUser } = useAuth();
  const { showNudge, onCancel } = useTrailNudge();

  return (
    showNudge && (
      <Flex
        bg="#0F62FE"
        justifyContent="center"
        alignItems="center"
        color="#fff"
        minH="44px"
        gap="16px"
        whiteSpace="nowrap"
        data-test-id="trial-nudge"
      >
        <Icon as={TrialStar} width="20px" height="20px" />
        <Flex fontWeight="medium" gap="4px" alignItems="center">
          <Text color="#fff">{`Your free trial ends ${
            dayjs(currUser?.account?.expires_at).diff(Date.now(), 'day') >= 1
              ? 'in'
              : ''
          }`}</Text>
          <Text fontWeight="semiBold" color="#fff">
            {getRemainingDays(currUser?.account?.expires_at)}.
          </Text>
          <Text color="#fff">Don't lose access,</Text>
          {currUser?.role === 'owner' || currUser?.role === 'admin' ? (
            <>
              <Link
                fontSize="14px"
                fontWeight="semiBold"
                color="#fff"
                textDecoration="underline"
                href="mailto:support@kula.ai"
              >
                Contact us
              </Link>
              <Text color="#fff">to upgrade your account now</Text>
            </>
          ) : (
            <Text color="#fff">
              Contact your Kula workspace admin to upgrade and continue hiring
              amazing team members.
            </Text>
          )}
        </Flex>
        <Icon
          cursor="pointer"
          as={X}
          width="16px"
          height="16px"
          onClick={onCancel}
        ></Icon>
      </Flex>
    )
  );
};
